import {Card, Input, Layout} from 'antd';
import React from 'react';

const { Content } = Layout;
const { TextArea } = Input;

export function CommentFragment(props) {
  const {
    formatMessage,
    comment,
    onChange,
    title,
    minRows = 15,
    maxRows = 15
  } = props;
  return (
    <Content
      style={{
        margin: 'auto',
        backgroundColor: 'white',
        width: '100%',
      }}
    >
      <Card
        title={<h2>{formatMessage({ id: title }).toUpperCase()}</h2>}
        bordered={false}
        style={{ width: '100%' }}
      >
        <div className="clearfix">
          <TextArea
            value={comment}
            placeholder={formatMessage({
              id: 'customer.journey.comment.commentPlaceholder',
            })}
            autosize={{ minRows, maxRows }}
            onChange={onChange}
          />
        </div>
      </Card>
    </Content>
  );
}



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/CommentFragment.js